import _objectSpread from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import http from 'http';
import https from 'https';
import urlMod from 'url';
import { BaseClient, BaseResponse } from './base';
import { AbortError } from '../../utils';

var HttpResponse =
/*#__PURE__*/
function (_BaseResponse) {
  _inherits(HttpResponse, _BaseResponse);

  /**
   * BaseResponse facade for node HTTP/HTTPS API Response
   * @param {http.ServerResponse} response
   */
  function HttpResponse(response, dataPromise) {
    var _this;

    _classCallCheck(this, HttpResponse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HttpResponse).call(this));
    _this.response = response;
    _this.dataPromise = dataPromise;
    return _this;
  }

  _createClass(HttpResponse, [{
    key: "getHeader",
    value: function getHeader(name) {
      return this.response.headers[name];
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.dataPromise;

              case 2:
                data = _context.sent;
                return _context.abrupt("return", data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "status",
    get: function get() {
      return this.response.statusCode;
    }
  }]);

  return HttpResponse;
}(BaseResponse);

export var HttpClient =
/*#__PURE__*/
function (_BaseClient) {
  _inherits(HttpClient, _BaseClient);

  function HttpClient(url) {
    var _this2;

    _classCallCheck(this, HttpClient);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(HttpClient).call(this, url));
    _this2.parsedUrl = urlMod.parse(_this2.url);
    _this2.httpApi = _this2.parsedUrl.protocol === 'http:' ? http : https;
    return _this2;
  }

  _createClass(HttpClient, [{
    key: "constructRequest",
    value: function constructRequest(headers, signal) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var request = _this3.httpApi.get(_objectSpread({}, _this3.parsedUrl, {
          headers: headers
        }), function (response) {
          var dataPromise = new Promise(function (resolveData) {
            var chunks = []; // collect chunks

            response.on('data', function (chunk) {
              chunks.push(chunk);
            }); // concatenate all chunks and resolve the promise with the resulting buffer

            response.on('end', function () {
              var data = Buffer.concat(chunks).buffer;
              resolveData(data);
            });
            response.on('error', reject);
          });
          resolve(new HttpResponse(response, dataPromise));
        });

        request.on('error', reject);

        if (signal) {
          if (signal.aborted) {
            request.destroy(new AbortError('Request aborted'));
          }

          signal.addEventListener('abort', function () {
            return request.destroy(new AbortError('Request aborted'));
          });
        }
      });
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _ref,
            headers,
            signal,
            response,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, headers = _ref.headers, signal = _ref.signal;
                _context2.next = 3;
                return this.constructRequest(headers, signal);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function request() {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }]);

  return HttpClient;
}(BaseClient);